export default __webpack_public_path__ + "static/media/DT.f6f56db6.jpeg";